// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"510":"dccecc21","707":"62878506","844":"24535679","858":"4e9b4516"}[chunkId] + ".css";
};